import projectQueries from '@apis/queries/projectQueries';
import { useQuery } from '@tanstack/react-query';

function useProjects() {
    const { data } = useQuery(projectQueries.list());
    return data?.projects;
}

export default useProjects;
